module.exports = __webpack_public_path__ + "img/61-image-1@2x.6e12fad3.png";